import * as Yup from 'yup';

export const BaselineSchema = Yup.object().shape({
  psfs1_act_1: Yup.string().required('PSFS kreves'),
  psfs1_1: Yup.string().required('PSFS Score kreves'),
  body_main_1: Yup.string().required('Diagnose kreves'),
});

